import { render, staticRenderFns } from "./birdStandard.vue?vue&type=template&id=fcd82248"
import script from "./birdStandard.vue?vue&type=script&lang=js"
export * from "./birdStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports